import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "userbar-click-wrapper" }
const _hoisted_2 = { class: "gt-userbar" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "ds-avatar ds-avatar--appearance_rounded ds-avatar--size_custom-sm" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "ds-avatar__label"
}
const _hoisted_7 = { class: "gt-userbar__info" }
const _hoisted_8 = { class: "gt-userbar__name ds-caption ds-caption--size_2sm ds-caption--medium" }
const _hoisted_9 = { class: "gt-userbar__arrow" }
const _hoisted_10 = {
  key: 0,
  class: "gt-userbar__content"
}
const _hoisted_11 = { class: "gt-userbar__menu" }
const _hoisted_12 = { class: "gt-userbar__icon" }
const _hoisted_13 = { class: "gt-userbar__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_chevron_down = _resolveComponent("i-chevron-down")!
  const _component_i_logout = _resolveComponent("i-logout")!
  const _component_ui_click_outside = _resolveComponent("ui-click-outside")!
  const _component_sidebar_trigger = _resolveComponent("sidebar-trigger")!

  return (_openBlock(), _createBlock(_component_sidebar_trigger, { "input-ref": _ctx.$emit }, {
    default: _withCtx(({ sidebarIsOpen, sidebarToggle, sidebarClose }) => [
      _createVNode(_component_ui_click_outside, {
        do: () => sidebarClose()
      }, {
        default: _withCtx(({ ref }) => [
          _createElementVNode("div", { ref: ref }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: "gt-userbar__main",
                  onClick: _withModifiers(sidebarToggle, ["prevent"])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["gt-userbar__avatar", {'is-active': sidebarIsOpen}])
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      ($setup.profile?.avatar)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "ds-avatar__image",
                            src: $setup.profile?.avatar.file
                          }, null, 8, _hoisted_5))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.profile?.firstName?.[0]), 1))
                    ])
                  ], 2),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(`${$setup.profile?.firstName} ${$setup.profile?.lastName}`), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["gt-userbar__arrow-wrapper", {'is-active': sidebarIsOpen}])
                    }, [
                      _createVNode(_component_i_chevron_down)
                    ], 2)
                  ])
                ], 8, _hoisted_3),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    sidebarIsOpen
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", {
                              class: "gt-userbar__menu-element",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.useLogout($setup.logoutQuestion)))
                            }, [
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_i_logout)
                              ]),
                              _createElementVNode("span", _hoisted_13, _toDisplayString($setup.$t('Log out')), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ])
            ])
          ], 512)
        ]),
        _: 2
      }, 1032, ["do"])
    ]),
    _: 1
  }, 8, ["input-ref"]))
}